e360.service('inviteesApi', [
   'apiHelper',
   function (apiHelper) {
      return {
         get: function (id) {
            return apiHelper.get('invitees/' + id).then(function (data) {
               if (data.dateOfBirth !== null) {
                  data.dateOfBirth = moment(data.dateOfBirth).toDate();
               }
               return data;
            });
         },
         update: function (invitee) {
            return apiHelper.post('invitees/' + invitee.id, invitee);
         },
         create: function (invitee) {
            return apiHelper.post('invitees', invitee);
         },
         del: function (id) {
            var url = 'invitees/';

            if (angular.isArray(id)) {
               url = url + 'bulk?ids=' + id.join('&ids=');
            } else {
               url = url + id;
            }

            return apiHelper.del(url);
         },
         list: function (params) {
            return apiHelper.get('invitees', params);
         }
      };
   }
]);
